import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { nationalContact } from '../cities';
import { Phone } from 'lucide-react';
import Header from './Header';
import RegionalAccordion from './RegionalAccordion';

const RegionsPage = () => {
  // Scroll nach oben beim Laden der Komponente
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#E8F5E0] to-white">
      {/* Header */}
      <Header />
      
      <div className="bg-[#1A3A2E] text-white py-16 pt-24">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              Wärmepumpen in Ihrer Region
            </h1>
            <p className="text-xl text-[#E8F5E0]/90 mb-6">
              Wir sind auch in Ihrer Region für Sie verfügbar
            </p>
            <div className="flex items-center justify-center gap-3 text-lg">
              <Phone className="w-6 h-6" />
              <a href={`tel:${nationalContact.phone}`} className="font-bold hover:text-[#E8F5E0] transition-colors">
                {nationalContact.phoneDisplay}
              </a>
              <span className="text-[#E8F5E0]/70 text-sm">
                ({nationalContact.description})
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Regionen Accordion */}
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-6xl mx-auto">
          <RegionalAccordion 
            theme="dark" 
            showSearch={true}
            containerClassName=""
          />
        </div>
      </div>

      {/* CTA Bereich */}
      <div className="bg-[#1A3A2E] text-white py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-bold mb-4">
              Ihre Region ist nicht dabei?
            </h2>
            <p className="text-xl text-[#E8F5E0]/90 mb-8">
              Kontaktieren Sie uns! Wir erweitern unser Netzwerk kontinuierlich und sind auch in Ihrer Region verfügbar.
            </p>
            <div className="flex flex-col md:flex-row gap-4 justify-center">
              <a
                href={`tel:${nationalContact.phone}`}
                className="bg-white text-[#1A3A2E] px-8 py-4 rounded-lg font-bold hover:bg-[#E8F5E0] transition-colors inline-flex items-center justify-center gap-2"
              >
                <Phone className="w-5 h-5" />
                {nationalContact.phoneDisplay}
              </a>
              <Link
                to="/waermepumpe"
                className="bg-[#E8F5E0] text-[#1A3A2E] px-8 py-4 rounded-lg font-bold hover:bg-white transition-colors"
              >
                Jetzt Angebot anfordern
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegionsPage;
